/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_LustraceInputs */

const cs_nav_lustrace = /** @type {(inputs: Nav_LustraceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lustrace`)
};

const en_nav_lustrace = /** @type {(inputs: Nav_LustraceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Due Diligence`)
};

/**
* | output |
* | --- |
* | "Due Diligence" |
*
* @param {Nav_LustraceInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const nav_lustrace = /** @type {((inputs?: Nav_LustraceInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_LustraceInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_nav_lustrace(inputs)
	return cs_nav_lustrace(inputs)
});